import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchTopBestContracts = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get(
            `mit/contract/suggestion?stockSymbols=${data.stockSymbols}&tradeDate=${data.tradeDate}`);
    }, options);
};

export const useFetchMitStocks = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("mit/stocks");
    }, options);
};